module.exports = __webpack_public_path__ + "img/www.angi.com.304e0b46.png";